import Image from "next/image";
import Logo from "@/app/(components)/generics/Logo/Logo";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import {
  FLOW_CALL_TIMER,
  FLOW_CALL_WAVE,
  FLOW_PARTICIPANT_PHOTO_HEIGHT,
  FLOW_PARTICIPANT_PHOTO_WIDTH,
  FLOW_PARTICIPANTS,
} from "../ConceptFlow.logic";
import styles from "../ConceptFlow.module.css";
import ConceptFlowWaveform from "./ConceptFlowWaveform";

export default function ConceptFlowCallCard() {
  const T = useT();

  return (
    <div className={`${styles.card} ${styles.callCard} ${styles.anchorRight}`} aria-hidden="true">
      <div className={styles.cardBar}>
        <span className={styles.cardTitle}>
          <span className={styles.liveDot} />
          <span className={styles.cardName}>{T(TKey.HOME_MEIDLY_FLOW_CALL_TITLE)}</span>
        </span>
        <span className={styles.mono}>{FLOW_CALL_TIMER}</span>
      </div>

      <div className={styles.tiles}>
        {FLOW_PARTICIPANTS.map((participant) => (
          <span
            className={`${styles.tile} ${participant.isSpeaking ? styles.tileSpeaking : ""}`}
            key={participant.photo}
          >
            <Image
              className={styles.tilePhoto}
              src={participant.photo}
              alt=""
              width={FLOW_PARTICIPANT_PHOTO_WIDTH}
              height={FLOW_PARTICIPANT_PHOTO_HEIGHT}
              unoptimized
            />
          </span>
        ))}
      </div>

      <div className={styles.callFooter}>
        <span className={styles.footerLogo}>
          <Logo min ignoreBrand nonInteractive />
        </span>
        <ConceptFlowWaveform bars={FLOW_CALL_WAVE} className={styles.callWave} />
        <span className={styles.recPill}>
          <span className={styles.recDot} />
          {T(TKey.HOME_MEIDLY_FLOW_CALL_REC)}
        </span>
      </div>
    </div>
  );
}
